import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";
import { WorkflowState } from "../workflow/nebula.service";

interface WorkflowDropdownProps {
    visitState: any;
    visitPossibleTransitions: any;
    onChange: (e: any) => void;
    workflowStates?: WorkflowState[];
}

const WorkflowDropdown: React.FC<WorkflowDropdownProps> = ({
    visitState,
    visitPossibleTransitions,
    onChange,
    workflowStates,
}) => {
    const stateColor: Record<string, string> = {
        LOW: "info.main",
        MEDIUM: "warning.main",
        HIGH: "error.main",
        HIGHEST: "error.main",
        DONE: "success.main",
        DEFAULT: "info.main",
    };
    const workflowVisitState = workflowStates?.find((workflowState) => workflowState.value === visitState?.value);

    const backgroundColor = workflowVisitState?.color ?? stateColor[visitState?.priority || "DEFAULT"];

    return (
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            {!visitState && <InputLabel sx={{ top: -5 }}>Loading...</InputLabel>}
            <Select
                displayEmpty
                renderValue={(transition: any) => transition?.label}
                sx={{
                    "& .MuiSelect-select": {
                        padding: "4px 8px",
                        opacity: 1,
                        webkitTextFillColor: "inherit",
                    },
                    "& .Mui-disabled": {
                        opacity: 1,
                        cursor: "not-allowed",
                        webkitTextFillColor: "white",
                        textAlign: "center",
                        paddingRight: "13px !important",
                    },
                    "backgroundColor": visitState
                        ? workflowVisitState?.color ?? stateColor[visitState.priority || "DEFAULT"]
                        : "inherit",
                }}
                disabled={!visitPossibleTransitions || !visitState || visitPossibleTransitions.length === 0}
                IconComponent={visitPossibleTransitions?.length === 0 ? () => null : undefined}
                onClick={(e: any) => e.stopPropagation()}
                value={visitState || ""}
                onChange={onChange}
            >
                {visitPossibleTransitions?.map((transition: any) => {
                    const workflowState = workflowStates?.find(
                        (workflowState) => workflowState.label === transition.value
                    );
                    return (
                        <MenuItem key={transition.value} sx={{ color: "inherit" }} value={transition.value}>
                            <Box
                                sx={{
                                    width: "12px",
                                    height: "12px",
                                    backgroundColor:
                                        workflowState?.color ?? (stateColor[transition.priority] || "info.main"),
                                    marginRight: "8px",
                                    borderRadius: "2px",
                                    display: "inline-block",
                                }}
                            />
                            {transition.value}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};

export default React.memo(WorkflowDropdown);
